/* eslint-disable max-len */
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import { history } from '../routers/AppRouter';
import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ROUTES from '../data/routes';
import { getListNotify, updateNotifyDisable, deleteNotify } from '../app/store/actions/notify';
import ModalComponent from '../components/modal';

class NotifyPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listNotify: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'id' , value: I18n.t('code') },
      { key: 'title'      , value: I18n.t('title') },
      { key: 'createdAt'  , value: I18n.t('createdIn') },
      { key: 'updatedAt'  , value: I18n.t('changedIn') },
      { key: 'isDisable'     , value: I18n.t('visibility') },
      { key: 'action'     , value: I18n.t('action') },
    ];
  }

  deleteNotify = async () => {
    this.setState({ showModal: false });
    try {
      await this.props.deleteNotify(this.state.selectedLine.id);
      await this.getListNotify();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  updateNotifyDisable = async (parameters = {}) => {
    try {
      await this.props.updateNotifyDisable({ ...parameters })

      await this.getListNotify();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  adjustData = async (count = 0, rows = []) => {
    const listNotify = rows.map((element, index) => ({
      key: index,
      id: element.id,
      title: element.title,
      description: element.description,
      createdAt: moment(element.createdAt).format('L LT'),
      updatedAt: moment(element.updatedAt).format('L LT'),
      isDisable: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${element.isDisable ? 'dark' : 'warning'} promotion-btn-${element.isDisable ? 'active' : 'warning'}`}
            onClick={() => this.updateNotifyDisable({ 
              id: element.id,               
              isDisable: !element.isDisable })}
          >
            {(element.isDisable)
              ? I18n.t('activeNotifications')
              : I18n.t('disableNotifications')
            }
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {history.push({
                      pathname: ROUTES.FORM,
                      screenComming: 'notify',
                      selectedNotify: element,
                  })
                }
                }
              >
                {I18n.t('edit')}
              </button>              
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  this.setState({
                    selectedLine: { ...element },
                    showModal: true,
                    showCancel: true,
                    titleModal: I18n.t('deleteNotify'),
                    titleModalBody: I18n.t('canNotBeUndone')
                  })
                }}
              >
                {I18n.t('delete')}
              </button>              
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      listNotify,
    });
  }

  getListNotify = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getListNotify(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch')
        })
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getListNotify();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getListNotify();
  }

  componentDidMount() {
    this.getListNotify();
  }

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'notify' }} />
      <button
        onClick={() => history.push(ROUTES.NOTIFY_HISTORY)}
        type="button"
        className="btn btn-primary margin-left-10"
      >
        {I18n.t('historic')}
      </button>
    </React.Fragment>
  )

  render() {
    const { limit, page, listNotify, totalRecord, titleModal, titleModalBody, showModal, showCancel } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => { showCancel ? this.deleteNotify() : this.setState({ showModal: false }) }}
        />
        <Table
          title={I18n.t('notification')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={listNotify}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getListNotify: (limit, skip, search, orderBy, field) => dispatch(getListNotify(limit, skip, search, orderBy, field)),
  updateNotifyDisable: (notify) => dispatch(updateNotifyDisable(notify)),
  deleteNotify: (id) => dispatch(deleteNotify(id)),
});

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(NotifyPage);
